/* bt-lead.js — заявки з вітрини → склад (вкладка «Заявки з сайту»).
 *
 * ОДНАКОВИЙ файл у двох темах (UA Bricktopia / PL Kloniko). Конфіг кладе
 * layout/theme.liquid інлайном ПЕРЕД цим асетом і перед content_for_header
 * (у редакторі теми — ні асета, ні конфігу):
 *   window.BT_LEAD_CFG = { api, store, notify, report }
 *     api    — https://<склад країни>/api/public/site-lead
 *     store  — 'UA' | 'PL' (за shop.currency)
 *     notify — kickflip /site/notify: старий шлях у Telegram, тепер лише запасний
 *     report — /api/health/storefront-error складу (журнал збоїв вітрини)
 *
 * window.btLead:
 *   send(payload, {fallbackText, fallbackParseMode, timeoutMs}) → Promise, що НІКОЛИ не reject:
 *     {ok:true, via:'sklad', id, no} | {ok:true, via:'telegram'} | {ok:false, status}
 *     (+ client_id у кожній відповіді — для підпису фото і пошуку дубля)
 *   beacon(payload) — нативні сабміти форм і кліки: sendBeacon І fetch keepalive
 *     з тим самим client_id (дубль склад відсіє), без запасного шляху
 *   uploadPhotos(res, files, {caption}) → Promise<{sent, fallback, failed}>
 *   cart(timeoutMs = 3000) → Promise<{raw, summary}>
 *   uuid()
 *
 * Запасний kickflip (повний текст у Telegram) — ТІЛЬКИ коли склад не відповів
 * по суті: мережа (сюди ж CORS: 401 замка / 404 Vercel без CORS-заголовків
 * браузер віддає як мережеву помилку), таймаут, 5xx, 429, 200 без id.
 * Будь-який інший 4xx (400/413 від складу) — без запасного, як у контракті
 * SITE-LEADS: інакше ПДн з кривої заявки все одно полетять у Telegram; лише
 * репорт, а форма показує свою помилку. Запасний спрацював → заявка лягає в
 * localStorage `bt_lead_pending` і при наступному завантаженні сторінки
 * дошлеться в склад з late:true (склад збереже, Telegram не повторить).
 * Будь-який запасний або відмова → репорт у storefront-error (без ПДн).
 *
 * Атрибуція: є window.btAttribution (UA, snippets/bt-attribution.liquid) —
 * беремо його {first, last}. Немає (PL) — цей файл сам пише перший/останній
 * візит у `bt_attr_v1` тією самою логікою, що й сніпет.
 *
 * Сумісність: Safari 14 / старий Android Chrome — ES5 без ?. і ??; кожне
 * браузерне API під перевіркою і try/catch. Публічні методи не кидають.
 */
(function () {
  'use strict';
  if (window.btLead && window.btLead.v) return;
  if (typeof Promise === 'undefined') return; /* без Promise — лишаються старі шляхи форм */

  var DEF_NOTIFY = 'https://web-production-05000.up.railway.app/site/notify';
  var DEF_REPORT = 'https://bricktopia.vercel.app/api/health/storefront-error';
  var TEXT_PLAIN = 'text/plain;charset=UTF-8'; /* safelisted — без CORS-preflight */
  var MAX_BODY = 60000;          /* байтів; склад приймає ≤ 64 КБ */
  var KEEPALIVE_MAX = 48000;     /* квота keepalive 64 КБ спільна зі sendBeacon і пікселями */
  var SEND_TIMEOUT = 10000;      /* склад має жорсткий бюджет ~5 с — відповідає раніше */
  var NOTIFY_TIMEOUT = 15000;
  var PHOTO_MAX = 4 * 1024 * 1024;
  var PHOTO_SIDE = 2400;
  var PHOTO_TIMEOUT = 60000;
  var PENDING_KEY = 'bt_lead_pending';
  var PENDING_MAX = 5;
  var PENDING_TTL = 7 * 24 * 3600 * 1000;
  var REPLAY_DELAY = 3000;
  var REPLAY_GAP = 60 * 1000;    /* склад лежить — не довбаємо його з кожної сторінки */
  var UUID_RE = /^[0-9a-f-]{36}$/;
  /* Відмова складу по суті: 4xx, крім 429 (ліміт — тимчасовий, це не оцінка заявки) */
  function isReject(status) { return status >= 400 && status < 500 && status !== 429; }
  var PHOTO_TYPES = { '': 1, 'image/jpeg': 1, 'image/jpg': 1, 'image/pjpeg': 1, 'image/png': 1, 'image/webp': 1, 'image/heic': 1, 'image/heif': 1 };

  /* ── дрібні помічники ─────────────────────────────────────────────────── */

  function cfg() {
    var c = null;
    try { c = window.BT_LEAD_CFG; } catch (e) {}
    return c && typeof c === 'object' ? c : {};
  }
  function now() { return new Date().getTime(); }
  function noop() {}
  function str(v, max) {
    var s = v === undefined || v === null ? '' : String(v);
    return max && s.length > max ? s.slice(0, max) : s;
  }
  function isArr(v) { return Object.prototype.toString.call(v) === '[object Array]'; }
  function isObj(v) { return !!v && typeof v === 'object' && !isArr(v); }
  function copy(o) {
    var r = {};
    if (isObj(o)) for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) r[k] = o[k];
    return r;
  }
  function stringify(o) { try { return JSON.stringify(o); } catch (e) { return ''; } }
  function storage(name) {
    try { var s = window[name]; if (s && typeof s.getItem === 'function') return s; } catch (e) {}
    return null;
  }

  function uuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        var u = String(window.crypto.randomUUID()).toLowerCase();
        if (UUID_RE.test(u)) return u;
      }
    } catch (e) {}
    var b = null, i;
    try {
      if (window.crypto && typeof window.crypto.getRandomValues === 'function' && typeof Uint8Array !== 'undefined') {
        b = new Uint8Array(16);
        window.crypto.getRandomValues(b);
      }
    } catch (e) { b = null; }
    if (!b) { b = []; for (i = 0; i < 16; i++) b.push(Math.floor(Math.random() * 256)); }
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var h = '';
    for (i = 0; i < 16; i++) {
      h += (b[i] + 0x100).toString(16).slice(1);
      if (i === 3 || i === 5 || i === 7 || i === 9) h += '-';
    }
    return h;
  }

  /* Довжина в байтах UTF-8 — саме її міряють keepalive-квота і ліміт складу. */
  function byteLen(s) {
    s = str(s);
    try { if (typeof TextEncoder !== 'undefined') return new TextEncoder().encode(s).length; } catch (e) {}
    var n = 0;
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      if (c < 0x80) n += 1;
      else if (c < 0x800) n += 2;
      else if (c >= 0xd800 && c < 0xdc00 && i + 1 < s.length) { n += 4; i++; }
      else n += 3;
    }
    return n;
  }

  function locale() {
    var l = '';
    try { l = (window.Shopify && window.Shopify.locale) || ''; } catch (e) {}
    if (!l) { try { l = document.documentElement.getAttribute('lang') || ''; } catch (e) {} }
    return str(l, 10);
  }

  function pageNoQuery() {
    try { return String(location.origin || '') + String(location.pathname || ''); } catch (e) { return ''; }
  }

  /* ── атрибуція: копія логіки snippets/bt-attribution.liquid (UA) ─────── */

  var ATTR_KEY = 'bt_attr_v1';
  var ATTR_TTL = 90 * 24 * 3600 * 1000;
  var ATTR_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid'];

  function attrRead() {
    try {
      var v = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null');
      if (v && v.first && Date.now() - v.first.ts > ATTR_TTL) return null;
      return v;
    } catch (e) { return null; }
  }
  function attrWrite(v) { try { localStorage.setItem(ATTR_KEY, JSON.stringify(v)); } catch (e) {} }
  function attrHost(url) { try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }

  function captureTouch() {
    var qs;
    try { qs = new URLSearchParams(location.search); } catch (e) { return null; }
    var t = {};
    var marked = false;
    for (var i = 0; i < ATTR_PARAMS.length; i++) {
      var val = qs.get(ATTR_PARAMS[i]);
      if (val) { t[ATTR_PARAMS[i]] = val.slice(0, 120); marked = true; }
    }
    var ref = document.referrer || '';
    var refHost = attrHost(ref);
    var external = refHost && refHost !== location.hostname.replace(/^www\./, '') && !/(^|\.)myshopify\.com$|(^|\.)shopify\.com$/.test(refHost);
    if (external) t.ref = refHost;
    if (!marked && !external) return null;
    t.landing = location.pathname.slice(0, 120);
    t.ts = Date.now();
    return t;
  }

  /* Лише коли сніпета немає (PL): UA сніпет уже все записав у той самий ключ. */
  function captureAttribution() {
    if (window.btAttribution) return;
    try {
      var state = attrRead() || {};
      var touch = captureTouch();
      var sessionKey = ATTR_KEY + '_s';
      var inSession = false;
      try { inSession = !!sessionStorage.getItem(sessionKey); sessionStorage.setItem(sessionKey, '1'); } catch (e) {}
      if (!state.first) {
        state.first = touch || { direct: true, landing: location.pathname.slice(0, 120), ts: Date.now() };
      }
      if (touch && (!inSession || touch.gclid || touch.utm_source || touch.fbclid)) {
        state.last = touch;
      } else if (!inSession && !touch && !document.referrer) {
        state.last = { direct: true, landing: location.pathname.slice(0, 120), ts: Date.now() };
      }
      attrWrite(state);
    } catch (e) {}
  }

  function attribution() {
    try {
      if (window.btAttribution && typeof window.btAttribution.get === 'function') {
        var a = window.btAttribution.get();
        return isObj(a) ? a : {};
      }
    } catch (e) {}
    var own = attrRead();
    return isObj(own) ? own : {};
  }

  /* Кліки на месенджер — аналітика, а не заявка: без згоди на аналітику не шлемо. */
  function clickAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (e) {}
    return true;
  }

  /* B2B-заявка (форма передала meta_lead): склад шле в Meta серверний дубль
     браузерного Lead з тим самим event_id 'lead_' + client_id. Для нього —
     згода (як у btTrack: заборонено лише при marketingAllowed() === false) і,
     якщо можна, cookie пікселя _fbp/_fbc. У базу склад їх не пише. */
  function cookie(name) {
    try {
      var parts = String(document.cookie || '').split(';');
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].replace(/^ +/, '');
        if (kv.indexOf(name + '=') === 0) return decodeURIComponent(kv.slice(name.length + 1)).slice(0, 500);
      }
      return '';
    } catch (e) { return ''; }
  }
  function adMarks() {
    var consent = true;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false) consent = false;
    } catch (e) {}
    var ad = { consent: consent };
    if (consent) {
      var fbp = cookie('_fbp'), fbc = cookie('_fbc');
      if (fbp) ad.fbp = fbp;
      if (fbc) ad.fbc = fbc;
    }
    return ad;
  }

  /* ── тіло запиту ──────────────────────────────────────────────────────── */

  var STR_FIELDS = ['kind', 'source', 'store', 'locale', 'page_url', 'page_title', 'name', 'contact_method', 'contact', 'phone', 'email', 'telegram', 'message'];

  function enrich(payload) {
    var p = copy(payload);
    for (var i = 0; i < STR_FIELDS.length; i++) {
      var f = STR_FIELDS[i];
      if (p[f] !== undefined && p[f] !== null && typeof p[f] !== 'string') p[f] = String(p[f]);
    }
    if (!(typeof p.client_id === 'string' && UUID_RE.test(p.client_id))) p.client_id = uuid();
    p.store = str(cfg().store) || p.store || '';
    if (!p.locale) p.locale = locale();
    if (!p.page_url) { try { p.page_url = String(location.href || ''); } catch (e) { p.page_url = ''; } }
    if (!p.page_title) { try { p.page_title = String(document.title || ''); } catch (e) { p.page_title = ''; } }
    p.details = isObj(p.details) ? copy(p.details) : {};
    if (!isObj(p.attribution)) p.attribution = attribution();
    p.notify = p.notify !== false;
    p.late = p.late === true;
    p.test = p.test === true;
    if (typeof p.meta_lead === 'string' && p.meta_lead) {
      if (!isObj(p.ad)) p.ad = adMarks();
    } else {
      delete p.meta_lead;
      delete p.ad;
    }
    return p;
  }

  /* Тіло ≤ 60 КБ: спершу викидаємо позиції кошика (там буває _builder_config
     і довгі властивості), далі ріжемо коментар. Далі — крайні заходи. */
  function fitBody(p) {
    var body = stringify(p);
    if (byteLen(body) <= MAX_BODY) return { body: body, p: p };
    var q = copy(p);
    q.details = copy(p.details);
    if (isObj(q.details.cart) && isArr(q.details.cart.items) && q.details.cart.items.length) {
      q.details.cart = copy(q.details.cart);
      q.details.cart.items = [];
      body = stringify(q);
      if (byteLen(body) <= MAX_BODY) return { body: body, p: q };
    }
    for (var n = 0; n < 8; n++) {
      var over = byteLen(body) - MAX_BODY;
      if (over <= 0) return { body: body, p: q };
      var m = str(q.message);
      if (!m) break;
      /* скільки символів відрізати — за середньою «вагою» символу коментаря
         (кирилиця 2 байти, лапки/переноси в JSON — 2); недобрали — ще коло */
      var mBytes = Math.max(1, byteLen(stringify(m)) - 2);
      m = m.slice(0, Math.max(0, m.length - Math.ceil(over * m.length / mBytes) - 16));
      if (/[\ud800-\udbff]$/.test(m)) m = m.slice(0, -1);
      q.message = m;
      body = stringify(q);
    }
    if (byteLen(body) <= MAX_BODY) return { body: body, p: q };
    delete q.details.cart;
    delete q.details.estimate;
    q.attribution = {};
    for (var i = 0; i < STR_FIELDS.length; i++) {
      if (typeof q[STR_FIELDS[i]] === 'string') q[STR_FIELDS[i]] = q[STR_FIELDS[i]].slice(0, 2000);
    }
    body = stringify(q);
    return { body: body, p: q };
  }

  /* ── мережа ───────────────────────────────────────────────────────────── */

  /* Один запит із таймаутом. Резолвить {status, json} або {status:0, error:
     'timeout'|'network', typeError}; ніколи не reject. Таймаут — перегони
     з таймером (працює і без AbortController), abort — якщо він є. */
  function request(url, init, timeoutMs) {
    return new Promise(function (resolve) {
      var done = false, timer = null, ac = null;
      function fin(v) {
        if (done) return;
        done = true;
        if (timer) clearTimeout(timer);
        resolve(v);
      }
      try {
        if (typeof AbortController !== 'undefined') { ac = new AbortController(); init.signal = ac.signal; }
      } catch (e) { ac = null; }
      timer = setTimeout(function () {
        fin({ status: 0, error: 'timeout' });
        try { if (ac) ac.abort(); } catch (e) {}
      }, timeoutMs > 0 ? timeoutMs : SEND_TIMEOUT);
      var p;
      try {
        p = window.fetch(url, init);
      } catch (e) {
        fin({ status: 0, error: 'network', typeError: !!(e && e.name === 'TypeError') });
        return;
      }
      if (!p || typeof p.then !== 'function') { fin({ status: 0, error: 'network' }); return; }
      p.then(function (r) {
        var status = r && typeof r.status === 'number' ? r.status : 0;
        if (!r || typeof r.text !== 'function') { fin({ status: status, json: null }); return; }
        r.text().then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) { j = null; }
          fin({ status: status, json: j });
        }, function () { fin({ status: status, json: null }); });
      }, function (e) {
        fin({ status: 0, error: 'network', typeError: !!(e && e.name === 'TypeError') });
      });
    });
  }

  /* POST з keepalive для малих тіл (заявка долетить, навіть якщо людина
     одразу пішла зі сторінки). Переповнена keepalive-квота дає миттєвий
     TypeError — тоді одразу повтор без keepalive. */
  function post(url, body, contentType, timeoutMs, allowKeepalive) {
    var ka = !!allowKeepalive && byteLen(body) < KEEPALIVE_MAX;
    var t0 = now();
    function once(useKa, ms) {
      var init = { method: 'POST', headers: { 'Content-Type': contentType }, body: body };
      if (useKa) init.keepalive = true;
      return request(url, init, ms);
    }
    return once(ka, timeoutMs).then(function (r) {
      var spent = now() - t0;
      if (ka && r.status === 0 && r.error === 'network' && r.typeError && spent < 1000) {
        return once(false, Math.max(1000, timeoutMs - spent));
      }
      return r;
    });
  }

  /* ── репорт збоїв (у журнал складу; ПДн не шлемо) ────────────────────── */

  var reportsLeft = 5;
  function report(stage, kind, status, extra) {
    if (reportsLeft <= 0) return;
    reportsLeft--;
    try {
      var c = cfg();
      var body = stringify({
        stage: stage,
        store: str(c.store) || '?',
        message: ('kind=' + str(kind, 30).replace(/[^a-z_]/gi, '') + ' status=' + status + (extra ? ' ' + extra : '')).slice(0, 300),
        url: pageNoQuery().slice(0, 300)
      });
      var p = window.fetch(str(c.report) || DEF_REPORT, {
        method: 'POST',
        headers: { 'Content-Type': TEXT_PLAIN },
        body: body,
        keepalive: true
      });
      if (p && typeof p.then === 'function') p.then(noop, noop);
    } catch (e) { /* репорт — best effort */ }
  }

  /* ── черга «доставлено запасним шляхом — дослати в склад» ─────────────── */

  function readPending(ls) {
    var list = [];
    try { list = JSON.parse(ls.getItem(PENDING_KEY) || '[]'); } catch (e) { list = []; }
    if (!isArr(list)) return [];
    var t = now(), out = [];
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      if (isObj(it) && typeof it.t === 'number' && Math.abs(t - it.t) < PENDING_TTL &&
          typeof it.client_id === 'string' && UUID_RE.test(it.client_id)) out.push(it);
    }
    return out;
  }
  function writePending(ls, list) {
    try {
      if (list.length) ls.setItem(PENDING_KEY, stringify(list));
      else ls.removeItem(PENDING_KEY);
    } catch (e) {}
  }
  /* delivered — Telegram уже має текст (у склад піде late:true, без другого алерту);
     ні — бережемо й сам запит у kickflip (fb), щоб повторити і його */
  function pushPending(p, delivered, fb) {
    var ls = storage('localStorage');
    if (!ls) return;
    try {
      var item = copy(p);
      item.late = delivered !== false;
      if (!item.late && isObj(fb)) item.fb = fb;
      item.t = now();
      var list = readPending(ls), kept = [];
      for (var i = 0; i < list.length; i++) if (list[i].client_id !== item.client_id) kept.push(list[i]);
      kept.push(item);
      while (kept.length > PENDING_MAX) kept.shift();
      writePending(ls, kept);
    } catch (e) {}
  }
  function markDelivered(clientId) {
    var ls = storage('localStorage');
    if (!ls) return;
    var list = readPending(ls);
    for (var i = 0; i < list.length; i++) {
      if (list[i].client_id === clientId) { list[i].late = true; delete list[i].fb; }
    }
    writePending(ls, list);
  }
  function dropPending(clientId) {
    var ls = storage('localStorage');
    if (!ls) return;
    var list = readPending(ls), kept = [];
    for (var i = 0; i < list.length; i++) if (list[i].client_id !== clientId) kept.push(list[i]);
    writePending(ls, kept);
  }

  var replaying = false;
  function replayPending() {
    if (replaying) return;
    var ls = storage('localStorage');
    var api = str(cfg().api);
    if (!ls || !api) return;
    var list = readPending(ls);
    writePending(ls, list); /* заодно чистимо протерміноване */
    if (!list.length) return;
    try {
      var last = parseInt(ls.getItem(PENDING_KEY + '_at') || '0', 10) || 0;
      if (now() - last < REPLAY_GAP && now() >= last) return;
      ls.setItem(PENDING_KEY + '_at', String(now()));
    } catch (e) {}
    replaying = true;
    var chain = Promise.resolve();
    list.forEach(function (item) {
      chain = chain.then(function () {
        var body = copy(item);
        var fb = body.fb;
        delete body.t;
        delete body.fb;
        body.late = item.late !== false;
        return post(api, stringify(body), TEXT_PLAIN, SEND_TIMEOUT, false).then(function (r) {
          /* ok (у т.ч. duplicate) — уже в складі; відмова по суті (400/413) —
             повтор нічого не змінить: теж прибираємо */
          if ((r.status === 200 && r.json && r.json.ok) || isReject(r.status)) { dropPending(item.client_id); return; }
          /* склад знову недоступний, а запасний шлях минулого разу теж не прийняв —
             пробуємо kickflip ще раз (він збереже і сам допише в склад) */
          if (!isObj(fb)) return;
          return post(str(cfg().notify) || DEF_NOTIFY, stringify(fb), 'application/json', NOTIFY_TIMEOUT, false).then(function (r2) {
            if (r2.json && r2.json.ok) markDelivered(item.client_id);
          });
        });
      });
    });
    chain.then(function () { replaying = false; }, function () { replaying = false; });
  }

  /* ── send / beacon ────────────────────────────────────────────────────── */

  /* Текст для Telegram, коли форма не дала свого: запасний шлях не мовчить */
  function autoText(p) {
    var out = ['[заявка з сайту · ' + (p.kind || '?') + ']'];
    if (p.name) out.push('👤 ' + p.name);
    var c = p.contact || [p.phone, p.email, p.telegram].filter(function (v) { return !!v; }).join(' · ');
    if (c) out.push('📞 ' + c);
    if (p.message) out.push('💬 ' + p.message);
    if (p.page_url) out.push('🌐 ' + p.page_url);
    return out.join('\n').slice(0, 3500);
  }

  /* Запасний шлях — kickflip /site/notify: повний текст у Telegram + сама заявка
     (lead): kickflip кладе її у свій резерв і сам дописує в склад (03.11.2026 —
     покупці з країн, де vercel.app заблоковано, інакше в CRM не потрапляли). */
  function fallback(p, opts, status) {
    return new Promise(function (resolve) {
      var text = str(opts.fallbackText) || (p.kind !== 'contact_click' ? autoText(p) : '');
      if (!text) {
        report('site-lead-fallback', p.kind, status, 'fallback=none');
        resolve({ ok: false, status: status });
        return;
      }
      var lead = copy(p);
      delete lead.late;
      var msg = { text: text + '\n🔖 ref ' + p.client_id.slice(0, 8), country: p.store, lead: lead };
      if (opts.fallbackParseMode) msg.parse_mode = str(opts.fallbackParseMode, 20);
      /* kickflip читає лише application/json (Flask get_json) */
      post(str(cfg().notify) || DEF_NOTIFY, stringify(msg), 'application/json', NOTIFY_TIMEOUT, true).then(function (r) {
        if (isRegionReply(r)) { showRegionNotice(); resolve({ ok: false, status: 'region' }); return; }
        var ok = !!(r.json && r.json.ok);
        report('site-lead-fallback', p.kind, status, ok ? 'fallback=ok' : 'fallback=fail');
        /* і так, і так — у чергу браузера: наступний захід на сайт повторить
           склад (а якщо kickflip теж не прийняв — і kickflip) */
        pushPending(p, ok, msg);
        if (ok) {
          resolve({ ok: true, via: 'telegram', id: null, no: null, status: status });
        } else {
          resolve({ ok: false, status: status });
        }
      });
    });
  }

  /* ── заявки з Росії не приймаємо (власник 03.11.2026) ──────────────────── */

  /* 11 цифр «7…», крім Казахстану (+7 6xx / 7xx), або «8 9xx…»; кілька контактів
     через «·» — кожен окремо. ⚠ Та сама логіка — склад isRussianPhone
     (lib/site-leads-core.ts) і kickflip is_russian_phone: міняти разом. */
  function isRuPhone(v) {
    var parts = String(v || '').split(/[·,;|\n]+/);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf('@') !== -1) continue;
      var d = parts[i].replace(/\D/g, '');
      if (d.length === 11 && ((d.charAt(0) === '7' && d.charAt(1) !== '6' && d.charAt(1) !== '7') ||
          (d.charAt(0) === '8' && d.charAt(1) === '9'))) return true;
    }
    return false;
  }
  function isRuLead(p) { return isRuPhone(p.phone) || isRuPhone(p.contact) || isRuPhone(p.telegram); }

  var REGION_TEXT = {
    uk: 'Ми не працюємо з Росією.', ru: 'Мы не работаем с Россией.',
    pl: 'Nie współpracujemy z Rosją.', de: 'Wir arbeiten nicht mit Russland zusammen.'
  };
  function showRegionNotice() {
    try {
      var l = locale().toLowerCase().slice(0, 2);
      var text = REGION_TEXT[l] || 'We do not work with Russia.';
      var old = document.getElementById('bt-region-notice');
      if (old) old.parentNode.removeChild(old);
      var box = document.createElement('div');
      box.id = 'bt-region-notice';
      box.setAttribute('role', 'alertdialog');
      box.style.cssText = 'position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.45);padding:16px';
      var card = document.createElement('div');
      card.style.cssText = 'background:#fff;color:#1d1d1f;border-radius:16px;padding:24px 28px;max-width:360px;font:500 17px/1.4 system-ui,sans-serif;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,.25)';
      card.textContent = text;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'OK';
      btn.style.cssText = 'display:block;margin:16px auto 0;padding:10px 28px;border:0;border-radius:999px;background:#1d1d1f;color:#fff;font:600 15px system-ui,sans-serif;cursor:pointer';
      btn.onclick = function () { if (box.parentNode) box.parentNode.removeChild(box); };
      card.appendChild(btn);
      box.appendChild(card);
      document.body.appendChild(box);
    } catch (e) {}
  }
  function isRegionReply(r) { return r && r.status === 403 && r.json && r.json.error === 'region'; }

  function send(payload, opts) {
    return new Promise(function (resolve) {
      var p = null;
      function done(res) {
        if (p && p.client_id) res.client_id = p.client_id;
        resolve(res);
      }
      try {
        opts = isObj(opts) ? opts : {};
        p = enrich(payload);
        if (p.kind === 'contact_click' && !clickAllowed()) { done({ ok: false, skipped: true }); return; }
        /* нікуди не шлемо: ні склад, ні Telegram */
        if (p.kind !== 'contact_click' && isRuLead(p)) { showRegionNotice(); done({ ok: false, status: 'region' }); return; }
        var fit = fitBody(p);
        p = fit.p;
        var api = str(cfg().api);
        var timeoutMs = opts.timeoutMs > 0 ? opts.timeoutMs : SEND_TIMEOUT;
        /* порожнє тіло (JSON.stringify не зміг) склад відбив би 400 — і заявка
           пропала б без запасного; тому одразу в запасний шлях */
        var first = api && fit.body
          ? post(api, fit.body, TEXT_PLAIN, timeoutMs, true)
          : Promise.resolve({ status: 0, error: api ? 'encode' : 'noapi' });
        first.then(function (r) {
          var j = r.json;
          if (r.status === 200 && j && j.ok && j.id) {
            done({ ok: true, via: 'sklad', id: String(j.id), no: j.no !== undefined && j.no !== null ? j.no : null, status: 200 });
            return;
          }
          /* клік понад ліміт — склад свідомо його не пише; це не збій */
          if (r.status === 200 && j && j.ok && j.dropped) {
            done({ ok: true, via: 'sklad', id: null, no: null, dropped: true, status: 200 });
            return;
          }
          var status = r.status ? r.status : (r.error || 'network');
          if (isRegionReply(r)) { showRegionNotice(); done({ ok: false, status: 'region' }); return; }
          if (isReject(r.status)) {
            report('site-lead-reject', p.kind, status);
            done({ ok: false, status: r.status });
            return;
          }
          return fallback(p, opts, status).then(done);
        }).then(null, function () { done({ ok: false, status: 'error' }); });
      } catch (e) {
        done({ ok: false, status: 'error' });
      }
    });
  }

  function beacon(payload) {
    try {
      var p = enrich(payload);
      if (p.kind === 'contact_click' && !clickAllowed()) return;
      var api = str(cfg().api);
      if (!api) return;
      var body = fitBody(p).body;
      if (!body) return;
      /* sendBeacon першим: він переживає навігацію надійніше (Firefox < 133
         ігнорує keepalive). fetch — страховка на випадок, коли beacon
         мовчки відкинули; однаковий client_id → склад запише один раз. */
      try {
        if (typeof navigator !== 'undefined' && navigator && typeof navigator.sendBeacon === 'function' && typeof Blob !== 'undefined') {
          navigator.sendBeacon(api, new Blob([body], { type: TEXT_PLAIN }));
        }
      } catch (e) {}
      post(api, body, TEXT_PLAIN, NOTIFY_TIMEOUT, true);
    } catch (e) {}
  }

  /* ── кошик ────────────────────────────────────────────────────────────── */

  var CFG_LABELS = {
    UA: { frameSize: 'Розмір рамки', frameColor: 'Колір рамки', figuresCount: 'Кількість фігурок', keychain: 'Брелок', delayDays: 'Затримка (днів)', type: 'Тип', yes: 'Так', no: 'Ні' },
    PL: { frameSize: 'Rozmiar ramki', frameColor: 'Kolor ramki', figuresCount: 'Liczba figurek', keychain: 'Brelok', delayDays: 'Opóźnienie (dni)', type: 'Typ', yes: 'Tak', no: 'Nie' }
  };

  function cut80(v) {
    var s = String(v);
    return s.length > 80 ? s.slice(0, 77) + '…' : s;
  }

  /* Та сама вибірка, що extractItemConfigForTelegram у layout/theme.liquid:
     поля _builder_config, Design ID, прев'ю і видимі властивості (без `_*`). */
  function itemSummary(it, L) {
    var props = isObj(it.properties) ? it.properties : {};
    var sp = {}, count = 0;
    function put(k, v) {
      if (count >= 15 || v === undefined || v === null || v === '' || v === false) return;
      sp[k] = cut80(v);
      count++;
    }
    var bc = null;
    var rawCfg = props._builder_config || props.builder_config;
    if (rawCfg) {
      try { bc = typeof rawCfg === 'string' ? JSON.parse(rawCfg) : rawCfg; } catch (e) { bc = null; }
    }
    if (!isObj(bc)) bc = null;
    if (bc) {
      if (bc.frameSize) put(L.frameSize, bc.frameSize);
      if (bc.frameColor) put(L.frameColor, bc.frameColor);
      if (bc.figuresCount) put(L.figuresCount, bc.figuresCount);
      if (bc.keychain !== undefined) put(L.keychain, bc.keychain ? L.yes : L.no);
      if (bc.delayDays) put(L.delayDays, bc.delayDays);
      if (bc.type) put(L.type, bc.type);
    }
    var designId = props._figure_config_id || props.figure_config_id ||
      props._frame_config_id || props.frame_config_id ||
      props._pet_config_id || props.pet_config_id || '';
    var keys = Object.keys(props), i;
    if (!designId) {
      for (i = 0; i < keys.length; i++) {
        if (/_config_id$/.test(keys[i]) && props[keys[i]]) { designId = props[keys[i]]; break; }
      }
    }
    var preview = props._preview_url || props.preview_url || (bc && bc.preview) || '';
    for (i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (k.charAt(0) === '_') continue;
      if (k === 'builder_config' || k === 'preview_url') continue;
      if (/_config_id$/.test(k)) continue;
      if (k.indexOf('bricktopia_price_') === 0) continue;
      put(k.slice(0, 60), props[k]);
    }
    var qty = parseInt(it.quantity, 10);
    return {
      title: str(it.product_title || it.title, 200),
      variant: it.variant_title && it.variant_title !== 'Default Title' ? str(it.variant_title, 200) : '',
      qty: qty > 0 ? qty : 1,
      price: it.line_price ? Math.round(Number(it.line_price) || 0) / 100 : 0,
      props: sp,
      design_id: str(designId, 200),
      preview: str(preview, 500)
    };
  }

  function summarizeCart(raw) {
    var L = CFG_LABELS[str(cfg().store) === 'PL' ? 'PL' : 'UA'];
    var list = isArr(raw.items) ? raw.items : [];
    var items = [];
    for (var i = 0; i < list.length && items.length < 30; i++) {
      if (isObj(list[i])) items.push(itemSummary(list[i], L));
    }
    return {
      count: Number(raw.item_count) || 0,
      total: raw.total_price ? Math.round(Number(raw.total_price) || 0) / 100 : 0,
      currency: str(raw.currency, 10),
      items: items
    };
  }

  function cart(timeoutMs) {
    return new Promise(function (resolve) {
      var empty = { raw: null, summary: null };
      try {
        request('/cart.js', {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        }, timeoutMs > 0 ? timeoutMs : 3000).then(function (r) {
          if (r.status >= 200 && r.status < 300 && isObj(r.json)) {
            var summary = null;
            try { summary = summarizeCart(r.json); } catch (e) { summary = null; }
            resolve({ raw: r.json, summary: summary });
          } else {
            resolve(empty);
          }
        }, function () { resolve(empty); });
      } catch (e) {
        resolve(empty);
      }
    });
  }

  /* ── фото ─────────────────────────────────────────────────────────────── */

  function jpgName(name) {
    var base = str(name, 100).replace(/\.[^.]*$/, '');
    return (base || 'photo') + '.jpg';
  }

  /* Декод: спершу <img> (враховує EXIF-орієнтацію), далі createImageBitmap. */
  function decodeImage(file) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = setTimeout(function () { fin(null); }, 20000);
      function fin(v) {
        if (settled) { if (v && v.free) v.free(); return; }
        settled = true;
        clearTimeout(timer);
        resolve(v);
      }
      function viaBitmap() {
        try {
          if (typeof window.createImageBitmap !== 'function') { fin(null); return; }
          window.createImageBitmap(file).then(function (bmp) {
            fin({ src: bmp, w: bmp.width, h: bmp.height, free: function () { try { if (bmp.close) bmp.close(); } catch (e) {} } });
          }, function () { fin(null); });
        } catch (e) { fin(null); }
      }
      try {
        var U = window.URL || window.webkitURL;
        if (!U || typeof U.createObjectURL !== 'function' || !window.Image) { viaBitmap(); return; }
        var url = U.createObjectURL(file);
        var img = new window.Image();
        var revoke = function () { try { U.revokeObjectURL(url); } catch (e) {} };
        img.onload = function () {
          var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
          if (!w || !h) { revoke(); viaBitmap(); return; }
          fin({ src: img, w: w, h: h, free: revoke });
        };
        img.onerror = function () { revoke(); viaBitmap(); };
        img.src = url;
      } catch (e) { viaBitmap(); }
    });
  }

  function toJpeg(dec) {
    return new Promise(function (resolve) {
      var c = null;
      var timer = setTimeout(function () { fin(null); }, 20000);
      function fin(v) {
        clearTimeout(timer);
        /* iOS Safari має спільний ліміт памʼяті на всі canvas; 2400² ≈ 23 МБ,
           а фото до 8 — звільняємо одразу, не чекаючи GC */
        try { if (c) { c.width = 0; c.height = 0; } } catch (e) {}
        resolve(v);
      }
      try {
        var scale = Math.min(1, PHOTO_SIDE / Math.max(dec.w, dec.h));
        var w = Math.max(1, Math.round(dec.w * scale));
        var h = Math.max(1, Math.round(dec.h * scale));
        c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var ctx = c.getContext ? c.getContext('2d') : null;
        if (!ctx) { fin(null); return; }
        ctx.fillStyle = '#ffffff'; /* прозорий PNG не стане чорним */
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(dec.src, 0, 0, w, h);
        if (typeof c.toBlob === 'function') {
          c.toBlob(function (b) { fin(b || null); }, 'image/jpeg', 0.85);
          return;
        }
        var data = String(c.toDataURL('image/jpeg', 0.85));
        var bin = atob(data.split(',')[1] || '');
        var arr = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        fin(new Blob([arr], { type: 'image/jpeg' }));
      } catch (e) { fin(null); }
    });
  }

  /* Що йде на склад: файл як є (≤ 4 МБ, звичний тип) або стиснений JPEG.
     null — склад його не прийме, фото піде запасним шляхом. */
  function prepareForSklad(file) {
    try {
      var type = str(file.type).toLowerCase();
      var size = typeof file.size === 'number' ? file.size : 0;
      if (size > 0 && size <= PHOTO_MAX && PHOTO_TYPES[type]) {
        return Promise.resolve({ blob: file, name: str(file.name, 120) || 'photo.jpg' });
      }
      return decodeImage(file).then(function (dec) {
        if (!dec) return null;
        return toJpeg(dec).then(function (b) {
          try { dec.free(); } catch (e) {}
          return b && b.size > 0 && b.size <= PHOTO_MAX ? { blob: b, name: jpgName(file.name) } : null;
        });
      }).then(null, function () { return null; });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  function photoToSklad(id, file) {
    return prepareForSklad(file).then(function (prep) {
      var api = str(cfg().api);
      if (!prep || !api) return false;
      var fd = new FormData();
      fd.append('photo', prep.blob, prep.name);
      return request(api + '/photo?id=' + encodeURIComponent(id), { method: 'POST', body: fd }, PHOTO_TIMEOUT).then(function (r) {
        return r.status >= 200 && r.status < 300 && !(r.json && r.json.ok === false);
      });
    }).then(null, function () { return false; });
  }

  /* client_id — kickflip перешле фото в склад до заявки, яку дописав сам;
     стиснена копія (≤4 МБ), якщо браузер уміє, — більшої склад не візьме */
  function photoToTelegram(file, caption, clientId) {
    return prepareForSklad(file).then(null, function () { return null; }).then(function (prep) {
      var fd = new FormData();
      if (prep) fd.append('photo', prep.blob, prep.name);
      else fd.append('photo', file, str(file.name, 120) || 'photo.jpg');
      fd.append('caption', str(caption, 1000));
      if (clientId) fd.append('client_id', str(clientId, 40));
      fd.append('country', str(cfg().store, 4));
      return request((str(cfg().notify) || DEF_NOTIFY) + '/photo', { method: 'POST', body: fd }, PHOTO_TIMEOUT).then(function (r) {
        return !!(r.json && r.json.ok);
      });
    }).then(null, function () { return false; });
  }

  function photoCaption(i, n, res, opts) {
    var c = '';
    try { if (opts && typeof opts.caption === 'function') c = opts.caption(i, n, res); } catch (e) { c = ''; }
    if (c) return String(c);
    var ref = res && res.no ? String(res.no) : ('ref ' + str(res && res.client_id).slice(0, 8));
    return '📎 Заявка #' + ref + ' — фото ' + i + '/' + n;
  }

  /* Послідовно, по одному фото. На склад — лише коли заявка лягла туди з id;
     фото, яке склад не взяв (не 2xx, мережа, 60 с), і всі фото заявки,
     що пішла запасним шляхом, — у kickflip /site/notify/photo. */
  function uploadPhotos(res, files, opts) {
    return new Promise(function (resolve) {
      var out = { sent: 0, fallback: 0, failed: 0 };
      try {
        var list = [];
        if (files && typeof files.length === 'number') {
          for (var i = 0; i < files.length; i++) if (files[i]) list.push(files[i]);
        }
        var n = list.length;
        if (!n || !res || !res.ok) { resolve(out); return; }
        var toSklad = res.via === 'sklad' && !!res.id && !!str(cfg().api);
        var chain = Promise.resolve();
        list.forEach(function (file, idx) {
          chain = chain.then(function () {
            var first = toSklad ? photoToSklad(res.id, file) : Promise.resolve(false);
            return first.then(function (ok) {
              if (ok) { out.sent++; return; }
              return photoToTelegram(file, photoCaption(idx + 1, n, res, opts), res.client_id).then(function (ok2) {
                if (ok2) out.fallback++; else out.failed++;
              });
            });
          }).then(null, function () { out.failed++; });
        });
        chain.then(function () { resolve(out); }, function () { resolve(out); });
      } catch (e) {
        resolve(out);
      }
    });
  }

  /* ── старт ────────────────────────────────────────────────────────────── */

  try { captureAttribution(); } catch (e) {}

  window.btLead = {
    v: 1,
    send: send,
    beacon: beacon,
    uploadPhotos: uploadPhotos,
    cart: cart,
    uuid: uuid
  };

  function scheduleReplay() {
    setTimeout(function () { try { replayPending(); } catch (e) {} }, REPLAY_DELAY);
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleReplay);
    else scheduleReplay();
  } catch (e) {}
})();
